module.exports = __webpack_public_path__ + "static/img/txt.cae87de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongqiu/txt.png
// module id = GQ6X
// module chunks = 1